import { HttpParams } from '@angular/common/http';
import { MockRoute, mockRoute } from '../mock-api';
import {
	buildBasiliskDashboard,
	buildCadastroDashboard,
	buildContestacaoDashboard,
	DashboardFilters,
} from './dashboards.const';

const DEFAULT_WINDOW_DAYS = 30;

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/** Data só com dia (`2026-09-01`) vira o início/fim daquele dia no fuso local */
function boundaryOf(value: string, edge: 'start' | 'end'): string {
	if (!DATE_ONLY.test(value)) return value;
	const time = edge === 'start' ? 'T00:00:00.000' : 'T23:59:59.999';
	return new Date(`${value}${time}`).toISOString();
}

/** Período e usuário pedidos; sem datas, usa os últimos 30 dias (mesmo padrão do Hub) */
function filtersOf(query: HttpParams): DashboardFilters {
	const end = new Date();
	const start = new Date(end.getTime() - DEFAULT_WINDOW_DAYS * 24 * 60 * 60 * 1_000);
	const startDate = query.get('startDate');
	const endDate = query.get('endDate');
	return {
		startDate: startDate ? boundaryOf(startDate, 'start') : start.toISOString(),
		endDate: endDate ? boundaryOf(endDate, 'end') : end.toISOString(),
		userId: query.get('userId') || null,
	};
}

export const DASHBOARD_MOCK_ROUTES: MockRoute[] = [
	mockRoute('GET', '/dashboards/cadastro/job', ({ query }) =>
		buildCadastroDashboard(filtersOf(query)),
	),
	mockRoute('GET', '/dashboards/contestacao/job', ({ query }) =>
		buildContestacaoDashboard(filtersOf(query)),
	),
	mockRoute('GET', '/dashboards/basilisk/job', ({ query }) =>
		buildBasiliskDashboard(filtersOf(query)),
	),
];
